import isEqual from 'lodash/isEqual';
import { Dispatch } from 'redux';

import { Events } from 'src/constants/webSocketConsts/events';
import { AppBuilder, appBuilderApi } from 'src/services/api/appBuilderApi';

// Fields whose change alone is not worth a cache write. The backend re-stamps
// updatedAt on bookkeeping writes every few seconds during a session; each
// write used to re-render the whole builder page (and rebuild every chat row)
// for a field nothing in the builder route displays.
const BOOKKEEPING_FIELDS = new Set<keyof AppBuilder>(['updatedAt']);

export function handleAppBuilderUpdate(
  event: Events,
  items: AppBuilder[],
  dispatch: Dispatch<any>,
) {
  const builder = items.at(0);
  if (!builder) {
    return;
  }
  if (event === Events.Remove) {
    return;
  }
  if (event === Events.Modify || event === Events.Insert) {
    dispatch(
      appBuilderApi.util.updateQueryData(
        'getAppBuilder',
        { id: builder.id },
        (draft: AppBuilder) => {
          const changed = (Object.keys(builder) as (keyof AppBuilder)[]).filter(
            (key) => !isEqual(draft[key], builder[key]),
          );
          // A recipe that writes nothing yields no patches, and RTK Query then
          // dispatches nothing: no store notification, no re-render.
          if (changed.every((key) => BOOKKEEPING_FIELDS.has(key))) return;
          for (const key of changed) {
            (draft as unknown as Record<string, unknown>)[key] = builder[key];
          }
        },
      ),
    );
  }
}
